import type { Severity } from "@shared/constants/severity";
import { SEVERITY_LABELS } from "@shared/constants/severity";

const SEVERITY_CLASSES: Record<Severity, string> = {
  mild: "bg-yellow-50 text-yellow-800 ring-1 ring-inset ring-yellow-300",
  moderate: "bg-amber-50 text-amber-900 ring-1 ring-inset ring-amber-300",
  severe: "bg-red-50 text-red-800 ring-1 ring-inset ring-red-400",
};

export function SeverityBadge({ severity }: { severity: Severity }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide ${SEVERITY_CLASSES[severity]}`}
    >
      {SEVERITY_LABELS[severity]}
    </span>
  );
}

export const SEVERITY_CARD_CLASSES: Record<Severity, string> = {
  mild: "border-l-4 border-l-yellow-500 bg-yellow-50",
  moderate: "border-l-4 border-l-amber-500 bg-amber-50",
  severe: "border-l-4 border-l-red-600 bg-red-50",
};
